import { render, staticRenderFns } from "./login.vue?vue&type=template&id=66646534&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=66646534&prod&lang=scss"
import style1 from "./login.vue?vue&type=style&index=1&id=66646534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66646534",
  null
  
)

export default component.exports